import { FileExcelOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useUploadFormStore } from 'stores/local/forms/UploadFormStore';

const SuccessFileState: React.FC = () => {
  const { uploadingFileData } = useUploadFormStore();

  return (
    <>
      <p className="ant-upload-drag-icon">
        <FileExcelOutlined />
      </p>
      <Typography.Text className="ant-upload-text">
        {uploadingFileData?.name}{' '}
      </Typography.Text>
      <Typography.Text className="ant-upload-hint">
        {uploadingFileData?.size}
      </Typography.Text>
    </>
  );
};

export default observer(SuccessFileState);
